import { connect } from "react-redux";
import { getters } from "../../store";

const mapStateToProps = state => ({
  county: getters.county(state)
});

export default connect(mapStateToProps);
